import { twJoin } from 'tailwind-merge';
import { createTwMerge } from './classNames.js';
/**
 * A tagged literal to define tailwindcss classes.
 *
 * This is similar to `classNames()` but you can configure IDE to support code completion with `tw`.
 */
export function tw(strings, ...args) {
    if (!args.every(isStringOrFalsyValue)) {
        throw new Error(`tailwind does not support dynamic expression.
Please make sure each argument is evaluated to a valid tailwind class name`);
    }
    return twJoin(toClasslists(strings, args));
}
function toClasslists(strings, args) {
    return strings.flatMap((s, i) => [...s.split(' '), args[i] || '']).map((s) => `${s}`.trim());
}
function isStringOrFalsyValue(value) {
    return typeof value === 'string' || !value;
}
/**
 * Creates a tailwind merge tagged template.
 */
export function createTwm({ prefix }) {
    const twMerge = createTwMerge({ prefix });
    return function twm(strings, ...args) {
        if (!args.every(isStringOrFalsyValue)) {
            throw new Error(`tailwind does not support dynamic expression.
	Please make sure each argument is evaluated to a valid tailwind class name`);
        }
        return twMerge(toClasslists(strings, args));
    };
}
/**
 * A tagged literal to merge tailwindcss classes.
 *
 * This is used by `panwds` internally with the `twds-` prefix.
 *
 * Applications and other libraries should create their own `twm` using the `createTwm` function
 */
export const twm = createTwm({ prefix: 'twds-' });
//# sourceMappingURL=tw.js.map